import { FEATURE_FLAGS } from "src/featureFlags";
import { generateTraceId } from "src/utils/generateTraceId";

export const renderTraceIdHeader = () => {
  const enableTraceId = FEATURE_FLAGS.enableTraceId;

  return enableTraceId && { "X-AVAIL-TRACEID": generateTraceId() };
};
